'use client'

import PropTypes from 'prop-types'
import { WizardFooter } from '@repo/ui/WizardFooter'
import { COISPartyCard } from '@repo/ui/COISPartyCard'
import MUIStack from '@mui/material/Stack'
import MUIButton from '@mui/material/Button'
import MUITypography from '@mui/material/Typography'
import { useCOISStore } from '@repo/store/useCOISStore'
import { useState } from 'react'
import { confirm } from '@repo/ui/Confirm'

export const COISReviewParties = ({ wideMode, handlePrevNext }) => {
  const {
    selectParty,
    partyIds,
    parties,
    updateCOISWizardSidebar,
    updateParty,
    currentPartyId,
    addParty,
    removeParty
  } = useCOISStore()
  const [partiesToShow, setPartiesToShow] = useState(partyIds ? [...partyIds] : null)

  const loadPartyDetails = (partyId) => {
    selectParty({ partyId })
    updateCOISWizardSidebar()

    // take them to the party details screen
    handlePrevNext(-3)
  }

  const addNewParty = () => {
    const partyId = Date.now()
    addParty({ partyId })
    selectParty({ partyId })
    updateCOISWizardSidebar()
    handlePrevNext(-3)
  }

  const deleteParty = async (e, partyId) => {
    e.stopPropagation()
    const shouldReset = await confirm('Are you sure you want to delete this party?')
    if (shouldReset) {
      removeParty({ partyId })
      setPartiesToShow(partyIds ? [...partyIds] : null)
      updateCOISWizardSidebar()
    }
  }

  const handleClickContinue = () => {
    updateParty({ partyId: currentPartyId, newFieldKey: 'addedAllParties', newFieldValue: true })
    updateCOISWizardSidebar()
    handlePrevNext(1)
  }

  const handleClickBack = () => {
    updateCOISWizardSidebar()
    handlePrevNext(-1)
  }

  return (
    <>
      <MUIStack data-testid="COISReviewParties" direction="column" alignItems="flex-end">
        <MUIButton variant="contained" color="primary" onClick={addNewParty}>
          Add party
        </MUIButton>

        {partiesToShow.length ? (
          <MUIStack direction="column" gap={4} sx={{ mt: 6, width: '100%' }}>
            <MUITypography variant="h6" sx={{ mb: 0 }}>
              Previous searches
            </MUITypography>

            {partiesToShow.map((partyId) => (
              <COISPartyCard
                key={partyId}
                partyId={partyId}
                parties={parties}
                handleClick={loadPartyDetails}
                editParty={() => loadPartyDetails(partyId)}
                deleteParty={deleteParty}
              />
            ))}
          </MUIStack>
        ) : null}
      </MUIStack>
      <WizardFooter wideMode={wideMode} handleClickContinue={handleClickContinue} handleClickBack={handleClickBack} />
    </>
  )
}

COISReviewParties.propTypes = {
  wideMode: PropTypes.bool,
  handlePrevNext: PropTypes.func
}
